import { z } from "zod";
import { structuredContentRootSchema } from "../content/structured/schema.js";
import { AutomationDeliveryProvider } from "./automation.js";
const automationArtifactIdSchema = z.uuid().brand();
function asAutomationArtifactId(id) {
  return automationArtifactIdSchema.parse(id);
}
function buildAutomationReportPath(automationArtifactId) {
  return `/agent-results/${encodeURIComponent(automationArtifactId)}`;
}
const automationArtifactContentSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("llm_output"),
    text: z.string()
  }),
  z.object({
    type: z.literal("structured"),
    /** The raw Markdown the agent produced, kept for reference. */
    text: z.string(),
    /** The parsed structured content AST the app renders. */
    content: structuredContentRootSchema
  })
]);
function buildLlmOutputArtifactContent(text) {
  return { type: "llm_output", text };
}
function buildStructuredArtifactContent(text, content) {
  return {
    type: "structured",
    text,
    content: structuredContentRootSchema.parse(content)
  };
}
function resolveAutomationArtifactEmailPreviewContent(body) {
  if (body.htmlBody?.trim()) {
    return { type: "html", content: body.htmlBody };
  }
  if (body.textBody?.trim()) {
    return { type: "text", content: body.textBody };
  }
  return null;
}
function filterSentAutomationArtifactEmailRecipients(recipients) {
  return recipients.filter(
    (recipient) => recipient.provider === AutomationDeliveryProvider.EMAIL && recipient.sent_at != null
  );
}
export {
  asAutomationArtifactId,
  automationArtifactContentSchema,
  automationArtifactIdSchema,
  buildAutomationReportPath,
  buildLlmOutputArtifactContent,
  buildStructuredArtifactContent,
  filterSentAutomationArtifactEmailRecipients,
  resolveAutomationArtifactEmailPreviewContent
};
//# sourceMappingURL=automationArtifact.js.map
